import { Ifilter } from "../filter"
import { IOpenPanel } from "../IPanel"

export interface IHistoriaEstadoEquipoDTO {
    historicoEstadoEquipoId: string
    equipoId: string
    equipo: string
    razonId: string
    razon: string
    operadorId: string
    operador: string
    turnoId: string
    turno: string
    horometro: number
    fechaHora: string
    fechaCreacion: string
    comentario: string
    ubicacionId: string
    ubicacion: string
    usuarioId: string
    usuario: string
    combustible: number
}

export interface IHistoriaEstadoEquipoRequest extends Ifilter {
    fechaDesde?: Date
    fechaHasta?: Date
    operadorId?: string
    estadoId?: string
}

export const InitialEstadoEquipoRequest = {
    skip: 0,
    take: 50,
    search: ""
}


export interface IPanelReporteHistoricoEstado extends IOpenPanel {
    filtro: IHistoriaEstadoEquipoRequest
    setFiltro: React.Dispatch<React.SetStateAction<IHistoriaEstadoEquipoRequest>>
}